module.exports = __webpack_public_path__ + "img/ammje.c7acc57f.jpg";